import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UserPickupShopsService } from '@checkout/feature';
import { DeviceService } from '@shared/services';
import { Pos } from '@shop/const';
import { ShopListService } from '@shop/feature';
import { Observable, combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'sd-pickup-user-shop-list',
  templateUrl: './pickup-user-shop-list.component.html',
  styleUrls: ['./pickup-user-shop-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorPickupUserShopListComponent implements OnInit {
  isMobile$: Observable<boolean>;
  loading$: Observable<boolean>;
  shopList$: Observable<Pos[]>;

  constructor(
    private shopListService: ShopListService,
    private userPickupShopsService: UserPickupShopsService,
    private deviceService: DeviceService,
  ) {}

  ngOnInit(): void {
    this.isMobile$ = this.deviceService.isMobileSmDown$;
    this.loading$ = this.userPickupShopsService.listLoading$;

    // Все магазины из самовывоза, но в порядке из сохраненных пользователем и доступных для выбора
    // Это нужно, так как в магазинах пользователя отсутствует дата самовывоза
    this.shopList$ = combineLatest([
      this.shopListService.shops$.pipe(filter<Pos[]>(Boolean)),
      this.userPickupShopsService.list$.pipe(filter<Pos[]>(Boolean)),
    ]).pipe(
      map(([pickupShops, userShops]: [Pos[], Pos[]]) =>
        userShops
          .map((userShop) => pickupShops.find((pickupShop) => userShop.name === pickupShop.name))
          .filter((shop) => Boolean(shop)),
      ),
    );
  }
}
